<template>
  <div class="grid-cell">
    <div
      class="grid-cell-image"
    >
      <a
        :id="`gridImage${data.id}`"
        @click="() => onPreview(data.id)"
      >
        <img
          v-show="data.base64Thumbnail"
          :src="'data:image/png;base64,' + data.base64Thumbnail"
          alt="thumbnail"
        >
      </a>
    </div>
  </div>
</template>

<script>
import { findRef } from '@/mixins/findRef'

export default {
  mixins: [findRef],
  inject: ['actions'],
  data () {
    return {
      data: {},
      ...this.actions(),
      templateBuilderQuery: this.$helpers.getTemplateBuilderQuery(this.$route)
    }
  },
  methods: {
    onPreview (templateId) {
      this.findRefByName('previewTemplateDialog').openDialog()
      this.$store.dispatch('setTemplateOnPreview', { ...this.templateBuilderQuery, templateId })
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  cursor: pointer;
}
.grid-cell-image {
  overflow: hidden;
  max-height: 52px;
  width: 60px;
  img {
    width: 60px
  }
}
</style>
